import { useState } from "react"

import {
  publicPartnerRetrieve,
  usePublicBoundlessConfigRetrieveSuspense,
} from "@boundless/bl-api-client/public/services"
import { createFileRoute, notFound, redirect } from "@tanstack/react-router"
import { z } from "zod"

import { SignupFormContent } from "@/components/account/SignupFormContent"
import { SignupNotEnabledContent } from "@/components/account/SignupNotEnabledContent"
import { VerifyEmailCodeForm } from "@/components/account/VerifyEmailCodeForm"

export const Route = createFileRoute("/(public)/p/$slug/signup")({
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
  }),
  beforeLoad: async ({ context: { store }, search }) => {
    if (store.getState().isAuthenticated) {
      throw redirect({ to: search.redirect || "/home" })
    }
  },
  loader: async ({ params }) => {
    const slug = params.slug
    try {
      await publicPartnerRetrieve(slug)
    } catch {
      throw notFound()
    }
  },
  component: RouteComponent,
  wrapInSuspense: false,
})

function RouteComponent() {
  const { slug } = Route.useParams()
  const [verifyEmail, setVerifyEmail] = useState<string | null>(null)
  const { data: config } = usePublicBoundlessConfigRetrieveSuspense()
  if (!config.signupEnabled) {
    return <SignupNotEnabledContent />
  }

  return verifyEmail ? (
    <VerifyEmailCodeForm email={verifyEmail} slug={slug} />
  ) : (
    <SignupFormContent onSuccess={setVerifyEmail} slug={slug} />
  )
}
